import { Cubit } from "blac-next";
import { ShippingAddressData } from "./ShippingAddressData";
import { Validation2AddressSuggestion } from "./Validation2AddressSuggestion";

interface AddressSuggestionState {
  originalAddress?: ShippingAddressData;
  suggestion?: Validation2AddressSuggestion;
  isSuggestionActive: boolean;
}

export class ShippingAddressSuggestionCubit extends Cubit<AddressSuggestionState> {
  constructor() {
    super({
      isSuggestionActive: false
    });
  }

  readonly updateShippingAddressSuggestion = (
    s: Partial<AddressSuggestionState>
  ) => this.patch(s);
}
